module.exports = __webpack_public_path__ + "assets/6ed3c513b5c6ce96625a20288adeb91d.mp4";